import React from 'react';
import { Box, Typography } from '@mui/material';
import { FormAutocomplete } from '~/components/FormComponents/FormAutocomplete.tsx';
import { FormDateInput } from '~/components/FormComponents/FormDateInput.tsx';
import { FormInput } from '~/components/FormComponents/FormInput.tsx';
import { REPORT_PERIOD_OPTIONS } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/constants.ts';
import { financialConditionGenerationStyles } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/styles.ts';
import { documentGenerationFormStyles } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/styles.ts';

interface IReportPeriodSectionProps {
  disabled: boolean;
  readOnly?: boolean;
}

export const ReportPeriodSection: React.FC<IReportPeriodSectionProps> = ({
  disabled,
  readOnly = false,
}) => {
  return (
    <Box sx={documentGenerationFormStyles.section}>
      <Typography component="h3" sx={documentGenerationFormStyles.sectionTitle}>
        Звітний період
      </Typography>
      <Box sx={financialConditionGenerationStyles.periodGrid}>
        <FormAutocomplete
          name="reportPeriod"
          label="Звітний період"
          options={REPORT_PERIOD_OPTIONS}
          disabled={disabled || readOnly}
          fullWidth
          sx={documentGenerationFormStyles.field}
        />
        <FormInput
          name="reportYear"
          label="Рік"
          type="number"
          inputProps={{ min: 2000, max: 2100 }}
          disabled={disabled || readOnly}
          fullWidth
          sx={documentGenerationFormStyles.field}
        />
        <FormDateInput
          name="reportDate"
          label="Станом на"
          disabled={disabled || readOnly}
          sx={documentGenerationFormStyles.field}
        />
      </Box>
    </Box>
  );
};
